import template from './employee_view_remuneration_component.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeViewRemunerationComponentViewModel {
	constructor(bindings) {
		this.bindings = bindings;
		this.employee_id = ko.observable();
		this.company_id = ko.observable();
		this.employee = ko.observable(null);
		this.logged_in_employee_id = Utils.get_local_storage_nullable('employee_id');
		this.employee_payslips = ko.observableArray([]);
		this.employee_irp5 = ko.observableArray([]);
		this.document_types = ko.observableArray();
		this.access_roles = ko.observableArray();
		if (bindings.employee && ko.isObservable(bindings.employee)) {
			bindings.employee.subscribe((nv) => {
				if (nv) {
					this.employee(nv);
					this.updateData();
				}
			});
		}
		if (bindings.employee_id && ko.isObservable(bindings.employee_id)) {
			bindings.employee_id.subscribe((nv) => this.employee_id(nv));
		}
		if (bindings.company_id && ko.isObservable(bindings.company_id)) {
			bindings.company_id.subscribe((nv) => this.company_id(nv));
		}
		this.remove_payslip_document = this.remove_payslip_document.bind(this);
		this.remove_irp5_document = this.remove_irp5_document.bind(this);
	}
	
	async updateData() {
		await this.loadPage();
	}
	
	async loadPage() {
		this.employee_id(this.employee().employee_id);
		this.company_id(this.employee().employment_info[0].company_id);
		console.log(this.employee());
		console.log(this.company_id());
		this.document_types(await Grape.cache.fetch('EmployeeDocumentTypeLookup'));
		this.access_roles(await Grape.cache.fetch('AccessRoleLookup') || []);
	
		// Call the SQL function to get payroll documents
		let payroll_res = await Grape.fetches.postJSON('/employee/get_payroll_documents', {employee_id: this.employee_id() });
			
		if (payroll_res && payroll_res.status === "OK" && payroll_res.documents) {
			
	
			// Categorize documents
			payroll_res.documents.forEach((docGroup) => {
				if (docGroup.type === 'UIF') {
					this.employee_irp5(docGroup.documents || []);
				} else if (docGroup.type === 'Payslip') {
					this.employee_payslips(docGroup.documents || []);
				}
			});
	
			console.log('Updated employee_irp5:', this.employee_irp5());
			console.log('Updated employee_payslips:', this.employee_payslips());
		}
	}
	
	async add_payslip_document(v, e) {
		await Grape.dialog.open('EmployeeUploadPayrollDocument', { employee_id: this.employee_id(), payslip: true });
		this.updateData();
	}

	async add_uif_document(v, e) {
		await Grape.dialog.open('EmployeeUploadPayrollDocument', { employee_id: this.employee_id(), uif: true });
		this.updateData();
	}

	async remove_payslip_document(v, e) {
		let data = ko.toJS(v);
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to remove this document?')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/employee/remove_payslip_documents', data);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted entry.'), title: tr('Success') });
				// Remove only the deleted payslip
				this.employee_payslips.remove(item => item.document_id === v.document_id);
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
		}
		this.updateData();
	}

	async remove_irp5_document(v, e)
	{
		let data = ko.toJS(v);
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to remove this document?')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/employee/remove_irp5_documents', data);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted entry.'), title: tr('Success') });
				// Remove only the deleted payslip
				this.employee_irp5.remove(item => item.document_id === v.document_id);
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
		}
		this.updateData();
	}
	
	async add_document_without_known_type() {
		await Grape.dialog.open('EmployeeUploadDocument', { employee_id: this.employee_id() });
		this.updateData();
	}
	
	download_document(v, e)
	{
		let data = ko.toJS(v);
		window.open(data.filename_link + '?download=yes', '_blank');
	}
	
	view_document(v, e) {
		let data = ko.toJS(v);
		window.open(data.filename_link, '_blank');
	}

	async request_salary_documents(v, e) {
		  const url    = '/payroll_integration/get_employee_payslips';
		  const params = {
		    employee_id: this.employee_id(),
		    company_id:  this.company_id()
		  };
		  
		  try {
		    // 1) Fire off the GET, but don't use getJSON (which parses JSON)
		    const qs  = new URLSearchParams(params).toString();
		    const res = await fetch(`${url}?${qs}`, { method: 'GET' });
		    console.log(res);
		    if (res.status === 409) {
			  // Show warning or skip saving
			  console.warn('Document already exists. Skipping...');
			  await Grape.alerts.alert({
			      type:    'error',
			      title:   tr('Error','Error'),
			      message: tr('Document for the period already exists. Skipping....')
		    	});
			  return;
			}
		    
		    // 2) Now refresh your list of documents
		    await this.loadPage();
		    
		    // 3) Finally show your success toast
		    await Grape.alerts.alert({
		      type:    'success',
		      title:   tr('Success','Success'),
		      message: tr('Successfully updated salary documents.')
		    });
		  }
		  catch (err) {
		    console.error('Error fetching salary documents:', err);
		    await Grape.alerts.alert({
		      type:    'error',
		      title:   tr('Error','Error'),
		      message: err.message
		    });
		  }
		}





}

export default {
	name: 'employee_view_remuneration_component',
	viewModel: EmployeeViewRemunerationComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/employee_view_remuneration_component'
};